import { JUNCTION_OPTIONS } from "src/base-components/FilterPopover/constants";
import { Select } from "src/base-components/Select";

type JunctionDropdownProps = {
  dataLoc: string;
  selectedKey: string;
  disabled?: boolean;
  onSelect: (key: string) => void;
};

export const JunctionDropdown: React.FC<JunctionDropdownProps> = ({
  dataLoc,
  selectedKey,
  disabled,
  onSelect,
}) => {
  return (
    <Select
      dataLoc={dataLoc}
      disabled={disabled}
      options={JUNCTION_OPTIONS}
      placeholder="and"
      value={selectedKey}
      onChange={onSelect}
    />
  );
};
